/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {NbButtonModule, NbCardModule, NbDialogRef} from '@nebular/theme';
import {TuiIcon} from '@taiga-ui/core';
import {TuiPush} from '@taiga-ui/kit';

@Component({
  templateUrl: './version-ready-dialog.component.html',
  styleUrls: ['./version-ready-dialog.component.scss'],
  imports: [TuiPush, TuiIcon, NbButtonModule, NbCardModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class VersionReadyDialogComponent {

  constructor(protected ref: NbDialogRef<VersionReadyDialogComponent>) {
  }

  protected toggle(result: boolean): void {
    this.ref.close(true);
    if (result) {
      window.location.reload();
    }
  }
}
